/**
 * Single source of truth for what counts as a "share" across Analytics.
 *
 * A share is recorded when the gallery link actually leaves the app. Today
 * that is the "Copy link" action inside the share modal (`link_copied`),
 * reachable from both the editor and the gallery. Opening the share modal is
 * intentionally NOT a share — it is only the entry point, and counting it
 * would misname the action and make shares an inflated superset of downloads
 * (you can only download from inside the same modal).
 *
 * `link_shared` is a legacy event that the current client never emits, but it
 * may exist on historical rows, so it still counts toward shares. New share
 * counting should reference SHARE_EVENT / isShareEvent rather than hardcoding
 * a string, so the editor, gallery, and dashboard can never drift again.
 */

/** The event the client emits today when a gallery link is copied to share. */
export const SHARE_EVENT = 'link_copied';

/** Legacy share event — never emitted by the current client, kept for history. */
export const LEGACY_SHARE_EVENT = 'link_shared';

/** Every event key that should be counted as one share. */
export const SHARE_EVENT_KEYS = [SHARE_EVENT, LEGACY_SHARE_EVENT];

const SHARE_EVENT_SET = new Set(SHARE_EVENT_KEYS);

/** True when the given event key should be counted as a share. */
export const isShareEvent = (event) => SHARE_EVENT_SET.has(event);
